import { onDeleteApiWhiteList, onGetApiWhitelist } from "mocksdata/whitelist";
import { handleResponse } from "utils/axios";
import { axiosInstance } from "./index";
import { onPostApiWhiteList } from "../mocksdata/whitelist";

/*Change Get Api here*/
const getApiWhitelist = async (query) => {
  //
  onGetApiWhitelist();
  return axiosInstance({
    method: "get",
    url: "/whitelist-merchant",
    params: query,
  }).then(handleResponse);
};

/*Change Post Api here*/
const postApiWhitelist = async (data) => {
  onPostApiWhiteList(data);
  return await axiosInstance.post("/whitelist-merchant", data).then(handleResponse);
};

/*Change Put Api here*/
const putApiWhitelist = async (id, data) => {
  return await axiosInstance.put("/whitelist-merchant", data).then(handleResponse);
};

/*Change Get Api here*/
const deleteApiWhitelist = async (id) => {
  onDeleteApiWhiteList(id);
  return await axiosInstance.delete(`/whitelist-merchant/${id}`).then(handleResponse);
};

export { getApiWhitelist, postApiWhitelist, putApiWhitelist, deleteApiWhitelist };
